// Media comes back as presigned S3 URLs: a new signature per response for the
// same file, so the browser sees a different resource each time and refetches
// one it already has. Serve the first URL seen for a path, re-adopting the
// newest before it expires.
const REUSE_WINDOW_MS = 30 * 60 * 1000;
const seen = {};

export const stableMediaUrl = url => {
  if (!url || typeof url !== 'string' || !url.includes('?')) {
    return url;
  }
  const [path] = url.split('?');
  const cached = seen[path];
  if (cached && Date.now() - cached.at < REUSE_WINDOW_MS) {
    return cached.url;
  }
  seen[path] = {url, at: Date.now()};
  return url;
};

export const resetStableMediaUrls = () => {
  Object.keys(seen).forEach(key => delete seen[key]);
};
